const initialState = {
    fetching: false,
    fetched: false,
    all: [],
    count: 0,
    error: null
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case 'SEARCH_FETCHING':
            state = { ...state, ...{ fetching: true } };
            break;
        case 'SEARCH_ERROR':
            state = { ...state, ...{ error: payload.error, fetched: true } };
            break;

        case 'SEARCH_FETCHED':
            state = { ...state, ...{ all: payload, fetching: false, fetched: true } };
            break;
        case 'SEARCH_COUNT_FETCHING':
            state = { ...state, ...{ fetching: true } };
            break;
        case 'SEARCH_COUNT_ERROR':
            state = { ...state, ...{ error: payload.error, fetched: true } };
            break;

        case 'SEARCH_COUNT_FETCHED':
            state = { ...state, ...{ count:  payload.length > 0 ? payload[0].count : 0, fetching: false, fetched: true } };
            break;
        default:
            break;
    }
    return state;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/app/reducers/search.js